import React from 'react'
import { MyProductivityLayout } from 'presentation/doctor/layouts/MyProductivity'
import { Doctor } from 'domain/entities/doctor-model'

export default function MyProductivity() {
  return <MyProductivityLayout doctors={[{} as Doctor]} />
}
